export default __webpack_public_path__ + "static/media/merge.c8476f46.svg";